import LoadCardSuspensionModal from './load-card-suspension-modal';

export default LoadCardSuspensionModal;
